module.exports = __webpack_public_path__ + "static/media/tony-3.fa54ea33.jpg";